/* eslint-disable import/no-unassigned-import */
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Import Rails UJS
import Rails from '@rails/ujs';

// Import application styles first (includes Market CSS via SCSS import)
import 'styles/application';

// Setup market library JS (CSS already loaded via SCSS above)
import {
  applyPolyfills,
  defineCustomElements,
} from '@market/web-components/loader';

// Import polyfills
import 'array-flat-polyfill';

// Import application js should be executed early
import 'application/ga_config';
import 'application/datadog_rum_config';
import 'application/utils';

import 'lib/public_web_nav';
import 'lib/sq_shop_footer';

// eslint-disable-next-line unicorn/prefer-top-level-await
applyPolyfills().then(() => {
  defineCustomElements(window);
});

// Initialize Rails UJS
Rails.start();

// Import all JS files under app/javascripts/packs.
// TODO(aiven): Move imports out of application.js and into individual JS files
// when we begin to move everything to ES modules.
const importAll = (r) => r.keys().forEach(r);
const context = require.context('application', true, /\.js\.es6$/);
importAll(context);

// Import React components
const componentRequireContext = require.context(
  'components',
  true,
  /^((?!\.test).)*$/, // Exclude *.test.* files
);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);
/* eslint-enable import/no-unassigned-import */
